import DownloadUtils from '../../DownloadUtils';
export const getItemDownloadDirectory = (item, uuid) => {
    const relative = `content/downloads/${uuid}/${item.id}`;
    return {
        relative,
        absolute: `${DownloadUtils.directories.documents}/${relative}`,
    };
};
//# sourceMappingURL=getItemDownloadDirectory.js.map